module.exports = __webpack_public_path__ + "img/yishi16.14b074e1.jpg";